import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["linkComponent", "openInNewTab"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Breadcrumb as BreadcrumbChakra, BreadcrumbItem, BreadcrumbLink, Link } from '@chakra-ui/react';
import { formatAssetsUrl, useSemanticTypography } from '@whitbread-eos/utils';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Breadcrumb(_ref) {
  var _props$items;
  var CustomLinkComponent = _ref.linkComponent,
    _ref$openInNewTab = _ref.openInNewTab,
    openInNewTab = _ref$openInNewTab === void 0 ? false : _ref$openInNewTab,
    props = _objectWithoutProperties(_ref, _excluded);
  var getTypographyProps = useSemanticTypography();
  var breadcrumbLinkSemanticTypography = {
    textStyle: 'body-xs-regular'
  };
  return _jsx(BreadcrumbChakra, _objectSpread(_objectSpread({}, props), {}, {
    children: (_props$items = props.items) === null || _props$items === void 0 ? void 0 : _props$items.map(item => _jsx(BreadcrumbItem, {
      isCurrentPage: item.isCurrentPage,
      children: CustomLinkComponent ? _jsx(CustomLinkComponent, {
        href: item.url,
        passHref: true,
        children: _jsx(BreadcrumbLink, _objectSpread(_objectSpread({}, getTypographyProps({}, breadcrumbLinkSemanticTypography)), {}, {
          children: item.name
        }))
      }) : _jsx(BreadcrumbLink, _objectSpread(_objectSpread({
        as: Link,
        isExternal: openInNewTab,
        href: openInNewTab ? formatAssetsUrl(item.url) : item.url
      }, getTypographyProps({}, breadcrumbLinkSemanticTypography)), {}, {
        children: item.name
      }))
    }, item.name))
  }));
}